import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import { FormattedHTMLMessage } from 'react-intl';
import { Segment, VerificationService } from '../../lib/types/types';
import { getFaqLink } from '../../lib/ProgramTheme/programThemeGetters';

interface Props {
    verificationService: VerificationService;
}

const FaqLinkComponent: React.SFC<Props> = ({ verificationService }) => {
    const segment = verificationService.verificationResponse.segment;
    const { programId, programTheme } = verificationService;

    if (segment) {
        const faqHref = getFaqLink(programTheme, segment, programId);

        return (
            <a className="sid-faq sid-link" href={faqHref} target="_blank">
                <FormattedHTMLMessage id="sheeridFaqs" defaultMessage="SheerID FAQs" />
            </a>
        );
    }
    return null;
};

export { FaqLinkComponent };
